import axios from 'axios';
import config from '../constants/config';
import { v4 as uuidv4 } from 'uuid';

const transactionAxios = axios.create();
const transactionsService = {};

/**
 * Non-invoice transaction
 * @function runTransaction
 * @param {PendingTransactionData} data
 * @returns {AxiosPromise}
 */
transactionsService.runTransaction = (data, options) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/transactions/`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'X-Correlation-ID': uuidv4(),
  };

  return transactionAxios.post(url, data, { headers, params: options });
};

/**
 * Send transaction receipts to the customer (for resending)
 * @function sendCustomerReceipts
 * @param {import('../../../types/common').ObjectIdType} transactionId
 * @returns {AxiosPromise}
 */
transactionsService.sendCustomerReceipts = (transactionId) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/transactions/${transactionId}/receipt`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'X-Correlation-ID': uuidv4(),
  };

  return transactionAxios.post(url, {}, { headers });
};

/**
 * Refund transaction
 * @function refundTransaction
 * @param {import('../../../types/common').ObjectIdType} transactionId
 * @param {{source: string, refundAmount: string}} data
 * @returns {AxiosPromise}
 */
transactionsService.refundTransaction = (transactionId, data) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/transactions/${transactionId}/refund`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'X-Correlation-ID': uuidv4(),
  };

  return transactionAxios.post(url, data, { headers });
};

/**
 * Manual refund
 * @function manualRefund
 * @param {{source: string, refundAmount: string}} data
 * @returns {AxiosPromise}
 */
transactionsService.manualRefund = (data) => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/transactions/refund`;
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
    'X-Correlation-ID': uuidv4(),
  };

  return transactionAxios.post(url, data, { headers });
};

export default transactionsService;
